var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediums(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.542,
    height: 34.391,
    viewBox: "0 0 45.542 34.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.129,
    cy: 0.205,
    r: 1.133,
    gradientTransform: "matrix(0.305, 0.952, -1.381, 0.443, 0.372, -0.008)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008ad1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#008ad1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#545199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#aa1761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#cd004b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f3711b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3711b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3092",
    transform: "translate(-478.929 -42.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2845",
    "data-name": "Group 2845",
    transform: "translate(478.929 42.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M10.285,36.752H4.336a4.336,4.336,0,1,1,0-8.672h6.175a9.915,9.915,0,0,0,9.8-7.527A9.723,9.723,0,0,0,10.84,8.672h-6.5A4.336,4.336,0,1,1,4.336,0h6.5A18.383,18.383,0,0,1,29.017,21.108c-1.283,8.932-9.331,15.662-18.732,15.662Z",
    transform: "translate(0 29.213) rotate(-90)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 6.077,
    height: 6.258,
    rx: 3.039,
    transform: "translate(15.256 29.213) rotate(-90)",
    fill: "#faa60e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2846",
    "data-name": "Group 2846",
    transform: "translate(506.863 59.392)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 8.804,
    cy: 8.804,
    r: 8.804,
    transform: "translate(0)",
    fill: "#bc1e2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M4.8,1.54,6.916,3.655,2.324,8.246.439,8.454A.4.4,0,0,1,0,8.017L.211,6.13,4.8,1.54Zm3.422-.315L7.231.233a.793.793,0,0,0-1.122,0l-.934.934L7.29,3.281l.934-.934a.793.793,0,0,0,0-1.122Z",
    transform: "translate(4.577 4.575)",
    fill: "#f5f5f5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediums);
export default __webpack_public_path__ + "static/media/mediums.4f5b4d5a178d684e79cda15ba2a9e84c.svg";
export { ForwardRef as ReactComponent };